module.exports = __webpack_public_path__ + "img/201601-1.a739c38e.jpg";